import { DateFormatter } from '@repo/toolkit/date'
import { toFullName } from '@repo/toolkit/to-full-name'

import { AffectedUser } from '../../../../components/pages/mission/affected-lists/utils'
import { MissionTime } from '../mission-time/mission-time'
import { Mission } from './mission'

export class MissionProperties {
  private static sortMissionTime(times: MissionTime[]): MissionTime[] {
    return times.sort(
      (a, b) =>
        DateFormatter.setTime(new Date(), a.time).getTime() -
        DateFormatter.setTime(new Date(), b.time).getTime()
    )
  }

  private static displayMissionTime(times: MissionTime[]): string {
    return times.length > 0
      ? MissionProperties.sortMissionTime(times)
          .map((missionTime) => DateFormatter.getFormattedTime(missionTime.time))
          .join(',')
      : '-'
  }

  static getDepartureTimes(mission: Mission): MissionTime[] {
    return MissionProperties.sortMissionTime(mission?.departureTimes)
  }

  static displayDepartureTimes(mission: Mission): string {
    return MissionProperties.displayMissionTime(MissionProperties.getDepartureTimes(mission))
  }

  static getArrivalTimes(mission: Mission): MissionTime[] {
    return MissionProperties.sortMissionTime(mission?.arrivalTimes)
  }

  static displayArrivalTimes(mission: Mission): string {
    return MissionProperties.displayMissionTime(MissionProperties.getArrivalTimes(mission))
  }

  static getMissionStaffNameAndBirthDate(staff: AffectedUser): string {
    const birthDate = staff.birthDate ? DateFormatter.DDMMYYYY(staff.birthDate) : ''
    return `${toFullName(staff.firstName, staff.lastName)} ${birthDate}`
  }
}
